module.exports = __webpack_public_path__ + "img/c05_unitspearman_Normal_ua.ca8a3297.webp";